import { useState, useEffect, Fragment } from "react";
import Config from "../../Config";
import back from "../../back.png";
import FormatDecimal from "../../helpers/FormatDecimal";
import InputLegend from "../../helpers/InputLegend";
import MenuTable from "../../helpers/MenuTable";
import ContractForm from "./ContractForm";
import ServiceForm from "./ServiceForm";
import ClientForm from "./ClientForm";
import InputCombo from "../../helpers/InputCombo";


function ContractReview(props)
{

            const [row, setRow] = useState(null); 
            const [view, setView] = useState ( "list");
 
            //dla uslug..
            const [selectedRow, setSelectedRow] = useState([]);

            //inne umowy - do przeniesienia usług        
            const [contractCombo, setContractCombo] = useState([]);
            const [targetContract, setTargetContract] = useState({
                ids: [],
                fak_umowy_id: -1
            });


            const [legend, setLegend] = useState([
                {
                    cls:'color_deleted',
                    title: 'usługa nieaktywna',
                   // filter: {  filed: "archiwalne", set: "1", typ: "combo"  },
                },
            ]);

            const changeView = (e ) => {
                    var v = e.target.getAttribute('v');
                    var id = e.target.getAttribute('id');

                    setView({...view, ["v"]:v, ["id"]:id });
            }
            

            const getContractDet = (idF) => {        

                    props.mainView.showProgress();
                

                    fetch( Config.url + '/rest_v1_home,contract_det', {
                        method: 'POST', 
                        body: JSON.stringify( { id: props.id}), 
                        headers: {
                            'Content-Type': 'application/json',                    
                            'X-Api-Key': props.userData.apiKey,
                            '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                            '_sec_key_': Config.genXKey() ,
                        }
                    })
                    .then(res => res.json() )
                    .then(res => { 

                                props.mainView.hideProgress();

                                if(res._sys_ == undefined)
                                {
                                    props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                                }else
                                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                {
                                    props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                                }else    
                                {
                                    setRow(res.result);                                                 


                                       var newSelector = [];
                                        res.result.uslugi.forEach( (item) => {
                                            newSelector.push({
                                                id: item.id,
                                                title: item.nazwa_uslugi  + "  " + item.abonament,
                                                selected: 0,
                                            });
                                        } )
                                        setSelectedRow(newSelector);


                                }
                    } )
                    .catch(err => {          
                                props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                                props.mainView.hideProgress();
                    });
                            

                    return false;
                }


            const getContractCombo = (idF) => {        

                    props.mainView.showProgress();
                

                    fetch( Config.url + '/rest_v1_home,contracts_combo', {
                        method: 'POST', 
                        body: JSON.stringify( { id: props.id}), 
                        headers: {
                            'Content-Type': 'application/json',                    
                            'X-Api-Key': props.userData.apiKey,
                            '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                            '_sec_key_': Config.genXKey() ,
                        }
                    })
                    .then(res => res.json() )
                    .then(res => { 

                                props.mainView.hideProgress();

                                if(res._sys_ == undefined)
                                {
                                    props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                                }else
                                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                {
                                    props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                                }else    
                                {
                                    setContractCombo(res.result);
                                }
                    } )
                    .catch(err => {          
                                props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                                props.mainView.hideProgress();
                    });
                            

                    return false;
            }



            const goMoveServices = () => {        

                    props.mainView.showProgress();
                

                    fetch( Config.url + '/rest_v1_home,services_move', {
                        method: 'POST', 
                        body: JSON.stringify( targetContract ), 
                        headers: {
                            'Content-Type': 'application/json',                    
                            'X-Api-Key': props.userData.apiKey,
                            '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                            '_sec_key_': Config.genXKey() ,
                        }
                    })
                    .then(res => res.json() )
                    .then(res => { 

                                props.mainView.hideProgress();

                                if(res._sys_ == undefined)
                                {
                                    props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                                }else
                                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                {
                                    props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                                }else    
                                {
                                    closeDialog();
                                    getContractDet();
                                    props.mainView.showDialog( "Sukces!",  "Usługa została przeniesiona" , "ok" , null);  
                                }
                    } )
                    .catch(err => {          
                                props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                                props.mainView.hideProgress();
                    });
                            

                    return false;
            }


            const valChangeListener = (filedName, val, correct, msg) => {
                
                   setTargetContract( {...targetContract, [filedName]:val,  [filedName+"_valid"]:correct } );                   
            }    



                //-------------------------------------------------------
                //-------------------------------------------------------
                //MASS
                const changeSelected = (e) => {

                    var id    = e.target.getAttribute('atr-id');   
                    var selected = 0;

                    if(e.target.checked) selected = 1;

                    for(var k=0; k<selectedRow.length; k++)
                    {
                        if(selectedRow[k].id == id)  selectedRow[k].selected = selected;
                    }

                    setSelectedRow(  JSON.parse(JSON.stringify(selectedRow) ) );    
                }

                const changeSelectedAll = (e) => {

                    var s = selectedRow[0].selected;
                    if(s == 1) {  s = 0; } else s = 1;

                    for(var k=0; k<selectedRow.length; k++)
                        {
                        selectedRow[k].selected = s;
                        }
                    
                        setSelectedRow(  JSON.parse(JSON.stringify(selectedRow) ) ); 

                }


                //-------------------------------------------------------
                //-------------------------------------------------------




            const deleteRecord = (e) => {
                
                var id = e.target.getAttribute('atr-id');
                var title = e.target.getAttribute('atr-title');

                props.mainView.showDialog("Pytanie" , "Czy na pewno chcesz usunąć: " + title  ,  "yesno"  , ( resp) => {

                                console.log("EEE", resp);
                                if(resp == "yes")
                                {
                                    //-----------------
                                
                                        props.mainView.showProgress();        

                                                fetch( Config.url + '/rest_v1_home,service_remove', {
                                                    method: 'POST', 
                                                    body: JSON.stringify({id: id}), 
                                                    headers: {
                                                        'Content-Type': 'application/json',                    
                                                        'X-Api-Key': props.userData.apiKey,
                                                        '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                                                        '_sec_key_': Config.genXKey() ,
                                                    }
                                                })
                                                .then(res => res.json() )
                                                .then(res => { 

                                                            props.mainView.hideProgress();

                                                            if(res._sys_ == undefined)
                                                            {
                                                                props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                                                            }else
                                                            if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                                            {
                                                                props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                                                            }else    
                                                            {
                                                                      getContractDet();
                                                                      props.mainView.showDialog( "Sukces", "Usługa została usunięta z umowy", "ok" , null);                                        
                                                            }
                                                } )
                                                .catch(err => {          
                                                            props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                                                            props.mainView.hideProgress();
                                                });

                                    //-----------------
                                }
                })

            }


            const onBack = () => {

               setView({...view, ["v"]:"list", ["id"]:-1 });   

            }

            const onSuccess = () => {
                getContractDet();
                setView({...view, ["v"]:"list", ["id"]:-1 }); 
            }


            const closeDialog = () => {
                setView({...view, ["v"]:"list", ["id"]:-1 });     
            }


       

            const goMove = () => {
        
                        var ids = new Array();
                                
                        for(var k=0; k<selectedRow.length; k++)
                            {
                            if( selectedRow[k].selected == 1)
                            {
                                    ids.push({
                                        id: selectedRow[k].id,
                                        title: selectedRow[k].title
                                    });
                            }
                            }
                        
                    
                        if(ids.length < 1)     
                        {       
                            props.mainView.showDialog("Ups", 'Nie wybrano żadnej usługi' ,  "error"  ,null); 
                            return;              
                        }

                        setTargetContract( {...targetContract, ["ids"]:ids,  ["ids_valid"]:true } );              

                        setView({
                            v:'move',
                            id: -1,
                            ids: ids,
                        });                    
                    }



            const keyListener = (e)   => {

                            var code = e.keyCode ? e.keyCode : e.which;    

                            if(e.target.nodeName.toLowerCase() != "body" && code == 27 )                                                  
                            {
                                    e.target.blur();
                            } else
                            if(e.target.nodeName.toLowerCase() == "body" && code == 27 )                                                  
                            {                                                        
                            }else  
                            if(e.target.nodeName.toLowerCase() == "body" && code == 8 )                                                  
                            {
                                    props.onBack();                               
                            }else
                            if (e.target.nodeName.toLowerCase() == "body" && code === 107) { //add +
                               setView({...view, ["v"]:'new', ["id"]:'-1' });
                            }else 
                            {
                                props.keyListener(e);
                            }


            }


            useEffect(() => {
        
                if(props.id > 0 && row == null)
                {
                    getContractDet();
                }
                

                           
                    if(Config.env == "dev") console.log("ContractReviewForm.js, listener on");
                    window.onkeydown = keyListener;

                    return () => {          
                        if(Config.env == "dev") console.log("ContractReviewForm.js, listener off");      
                        window.onkeydown = props.keyListener;
                    };

            });
   


            if(row == null )
            {
                return <div>....</div>
            }


             if(view.v == "edit_um")
            {
                return <ContractForm userData={props.userData} mainView={props.mainView} keyListener={keyListener} onBack={onBack} onSuccess={onSuccess}  id={view.id}  umowa={row}   />
            }

            if(view.v == "edit_cl")
            {
                return <ClientForm userData={props.userData} mainView={props.mainView} keyListener={keyListener}  onBack={onBack} onSuccess={onSuccess}  id={view.id}  umowa={row}   />
            }

            if(view.v == "edit")
            {
                return <ServiceForm userData={props.userData} mainView={props.mainView} keyListener={keyListener} onBack={onBack} onSuccess={onSuccess}  id={view.id}  umowa={row}   />
            }

            if(view.v == "new")
            {
                return <ServiceForm userData={props.userData} mainView={props.mainView} keyListener={keyListener} onBack={onBack} onSuccess={onSuccess}  id={-1}  umowa={row} /> 
            }


       




             var zaznaczonych = 0;
            for(var s=0; s<selectedRow.length; s++)
            {
                if(selectedRow[s].selected == 1) zaznaczonych ++;
            }



                 
            var dialog = null;
            if(view.v == "move")
            {
                if(contractCombo.length == 0) getContractCombo();

                
             
            
                dialog =     <div className="dlg_window shadowx z-max"  >
                                    <div className="dlg_title" >Przeniesienie usług ({zaznaczonych})</div>
                                    <div className="dlg_msg"> 

                                        <div className="form_tab">
                                            <div className="form_control">
                                                <div className="fieldName">Umowa docelowa*</div>
                                                <InputCombo  items={ contractCombo}  userData={props.userData} value={targetContract.fak_umowy_id} err={null}  valChange={valChangeListener} goNext={null} name="fak_umowy_id" placeholder={""} className=' ' req='1' firstUp="1" />
                                            </div>
                                        </div>

                                    </div>
                                    <div className="dlg_btn">
                                        <div className="btn" atr-type="yes" onClick={closeDialog}>Anuluj</div>
                                        &nbsp; &nbsp;
                                        <div className="btn" atr-type="no" onClick={goMoveServices}>Wykonaj</div>
                                    </div>
                            </div>
            
            }


            document.title = "Umowa " + row.numer_umowy;


            return <div className="view_content">

                    <img src={back} onClick={props.onBack} className="back_img" title="wstecz"/>

                     <div className="location">Panel / Lista umów / Szczegóły umowy</div> 
                    
                       <h3 className="app_header">
                        {row.klient.nazwa}     &nbsp;
                        <sup className="link_normal" v="edit_cl" id={row.klient.id} onClick={changeView}>zmień dane klienta</sup> / Umowy / {row.numer_umowy}
                        &nbsp;
                        <sup className="link_normal" v="edit_um" id={row.id} onClick={changeView}>zmień dane umowy</sup>
                       </h3>



                    <div className="client_info">    
                          <div>
                            { 
                                row.stan_umowy == 0 &&
                                <Fragment>Umowa jest nieaktywna</Fragment>
                            }
                            { 
                                row.stan_umowy == 1 &&
                                <Fragment>Umowa jest aktywna</Fragment>
                            }
                          </div>
                          <div>Nr {row.numer_umowy} z dnia {row.data_zawarcia}</div>
                          <div>Data i czas utworzenia {row.created_at}, ostatnia aktualizacjia rekordu {row.updated_at}</div>
                    </div>

                    <div className="client_info">  
                            <div>E-Faktura:&nbsp; 
                                {
                                    row.e_faktura == 1 &&
                                    <Fragment>tak, na adres {row.e_mail_dla_faktur}</Fragment>
                                }
                                {
                                    row.e_faktura == 0 &&
                                    <Fragment>nie</Fragment>
                                }
                            </div>
                    </div>

                    <div className="client_info">  
                            <div>Informacje dodatkowe: {row.informacje_dodatkowe}</div>
                    </div>

                    <h3 className="dash_header">Lista usług w ramach umowy ({row.uslugi.length})</h3>


                    <div className="bg_center">


                            <div className="table_widget">
                                        <div className="btn" onClick={changeView} v="new" id="-1"  > nowa usługa [+]</div>                                               

                                        &nbsp; &nbsp;                                      
                                        <InputLegend items={legend}  valChange={valChangeListener} /> 
                            </div>


                          
                                <div className="table_mass">  
                                    <div className="title_mass">Operacje masowe (zaznaczono: {zaznaczonych}) </div>
                                    &nbsp;
                                    <span className="btn" onClick={goMove}  >Przenieś do innej umowy</span>                                                                                             
                                </div>
                       
                           

                         <table className="table"  >

                                        <thead>
                                            <tr className="header">                                                                                               
                                                <td className="td_left">  </td>
                                                <td >LP</td>
                                                <td>ID Usługi</td>                                                                                                                                    
                                                <td>Nazwa pozycji</td>                                                                                                                                    
                                                <td>Numer PSTN</td>                                                                                                                                    
                                                <td>Numer infolinii</td>                                                                                                                                    
                                                <td>AccountCode</td>                                                                                      
                                                <td>Osobna faktura</td>                                                                                      
                                                <td>Aktywacja</td>                                                                                      
                                                <td>Abonament</td>                                                                                      
                                                <td>Stawka VAT</td>                                                                                      
                                                <td>Aktywne od</td>                                                                                      
                                                <td className="td_right">Aktywne do</td>                                                  
                                                <td className="td_option"></td>                                                                                  
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {
                                                row.uslugi.map( (us, inx) => {

                                                       var rowStyle = " row ";
                                                        if(inx % 2 == 0 )rowStyle = " row2 ";

                                                        if(us.usluga_aktywna == '0')
                                                        {
                                                            rowStyle = rowStyle + " color_deleted ";
                                                        }


                                                        var isChecked = "";

                                                        for(var s=0; s<selectedRow.length; s++)
                                                        {
                                                            if( selectedRow[s].id == us.id &&  selectedRow[s].selected == 1) isChecked = "checked";
                                                        }


                                                        return    <tr className={rowStyle} >  

                                                                    <td className="gocenter ">
                                                                        <input type="checkbox" atr-id={us.id} onChange={changeSelected} checked={isChecked} />
                                                                    </td>                                                                                    
                                                                    <td className="gocenter">{inx+1}</td>                                                                    
                                                                    <td  className="gocenter">{us.id}</td>                                                                                                                                    
                                                                    <td  v="edit" id={us.id} onClick={changeView} >{us.nazwa_uslugi}</td>                                                                                                                                    
                                                                    <td  v="edit" id={us.id} onClick={changeView} className="gocenter">{us.numer_pstn}</td>                                                                                                                                    
                                                                    <td  v="edit" id={us.id} onClick={changeView} className="gocenter">{us.numer_info}</td>                                                                                                                                    
                                                                    <td  v="edit" id={us.id} onClick={changeView} className="gocenter">{us.accountcode}</td>                                                                                      
                                                                    <td className="gocenter">
                                                                        {
                                                                            us.osobna_faktura == 0 &&
                                                                            <Fragment>Nie</Fragment>
                                                                        }
                                                                        {
                                                                            us.osobna_faktura == 1 &&
                                                                            <Fragment>Tak</Fragment>
                                                                        }
                                                                    </td>                                                                                      
                                                                    <td className="goright"><FormatDecimal value={us.aktywacja}/></td>                                                                                      
                                                                    <td className="goright"><FormatDecimal value={us.abonament}/></td>                                                                                      
                                                                    <td className="gocenter"><FormatDecimal value={us.stawka_vat}/></td>                                                                                      
                                                                    <td className="gocenter">{us.data_rozpoczecia_uslugi}</td>                                                                                      
                                                                    <td className="gocenter">{us.data_zakonczenia_uslugi}</td>                                                  
                                                                    <MenuTable>
                                                                        <ul>                                                        
                                                                            <li v="edit" id={us.id} onClick={changeView}>Zmień dane</li>
                                                                            <li v="delete" atr-id={us.id} atr-title={us.nazwa_uslugi} onClick={deleteRecord}>Usuń</li>
                                                                        </ul>
                                                                    </MenuTable>                                                                                
                                                                </tr>

                                                } )
                                            }
                                        </tbody>

                         </table>
                    </div>

                   {dialog}
            </div>
}


export default ContractReview;